export const STARRED_PROFESSIONAL_COLOR = "#1890FF";
